import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes } from './routeConfig';
import ProtectedRoute from './ProtectedRoute';
import RouteFallback from './RouteFallback';

export const PublicRouteGuard = ({ auth, setAuth, isSidebarOpen }) => {
  // Handle scenario: authenticated user trying to access public routes
  // Redirect them to their appropriate dashboard
  const handleAuthenticatedUserRedirect = (routePath) => {
    if (auth?.isLoggedIn && routePath !== "*") {
      // Don't redirect if it's the catch-all route (prevents infinite loops)
      const userType = auth.userType;
      const redirectPath = userType === 'wholesaler' ? '/credits' : '/overview';
      console.log(`PublicRouteGuard: Authenticated user accessing public route ${routePath}, redirecting to ${redirectPath}`);
      return redirectPath;
    }
    return null;
  };

  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        {publicRoutes.map((route, index) => {
          const redirectPath = handleAuthenticatedUserRedirect(route.path);

          return (
            <Route
              key={`${route.path}-${index}`}
              path={route.path}
              element={
                redirectPath ? (
                  <Navigate to={redirectPath} replace />
                ) : (
                  <ProtectedRoute
                    element={route.element}
                    permission={route.permission}
                    auth={auth}
                    setAuth={setAuth}
                    isSidebarOpen={isSidebarOpen}
                  />
                )
              }
              {...(route.exact && { exact: true })}
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

export default PublicRouteGuard;
